import React, { useMemo } from 'react';
import Button from 'components/base/button/button';
import { Trans } from '@lingui/macro';
import { ObservationPointDecorated } from 'util/backendapi/types/Model';
import moment from 'moment-timezone';
import { formatDateForBackendapi } from 'util/dates';

export interface CumulativePlotMouseoverPoint {
  x: number;
  y: number;
  year: number;
  seriesColor: string;
  marker: string;
}

type Props = {
  point: CumulativePlotMouseoverPoint;
  observationPoint: ObservationPointDecorated;
  onClose: () => void;
};

export const CumulativePlotReadingInfo = React.memo((props: Props) => {
  const { point, observationPoint, onClose } = props;

  const dateString = useMemo(() => {
    const isoDate = formatDateForBackendapi(
      moment().year(point.year).dayOfYear(point.x)
    );
    return moment(isoDate)
      .tz(observationPoint.time_zone.name)
      .format('DD/MM/YYYY z');
  }, [point, observationPoint]);

  const units = observationPoint.instrument_type.standard_units;

  return (
    <div className="plot-popup-timeseries">
      <div className="plot-popup-timeseries-info">
        <p>
          <strong>{observationPoint.code}</strong>
        </p>
        <Button
          iconOnly
          onClick={onClose}
          iconType="icon-cross"
          shortcut="ESC"
          className="close"
        >
          <Trans>Close</Trans>
        </Button>
        <>
          <p>
            {dateString}
            <br />
            <strong>
              {point.y}
              {units}
            </strong>
          </p>
        </>
      </div>
      <div
        className="plot-popup-timeseries-action"
        style={{ backgroundColor: point.seriesColor }}
      ></div>
    </div>
  );
});
